// @flow
import {
  PrimaryFormPayload,
  getPrimaryFormPayload,
  assignOtherInformation,
} from 'hooks/mutations/useSavePrimaryFormMutation.utils';
import { booleanToYesNo, getValueOrNull } from 'utils';

interface SecondaryFormPayload extends PrimaryFormPayload {
  additionalOccupants: {
    anyAdult: 'yes' | 'no' | null,
    anyMinor: 'yes' | 'no' | null,
  };
  otherInformation: {
    pets: 'yes' | 'no' | null,
  };
}

export const getSecondaryFormPayload = ({
  initialData,
  update,
  states,
}: {
  initialData: SecondaryFormPayload,
  update: SecondaryFormPayload,
  states: Array<Object>,
}): SecondaryFormPayload => ({
  ...getPrimaryFormPayload({
    initialData,
    update,
    states,
  }),
  additionalOccupants: {
    anyAdult: getValueOrNull(
      booleanToYesNo(update?.additionalOccupants?.adults?.anyAdult) ??
        booleanToYesNo(initialData?.additionalOccupants?.anyAdult),
    ),
    anyMinor: getValueOrNull(
      booleanToYesNo(update?.additionalOccupants?.minors?.anyMinor) ??
        booleanToYesNo(initialData?.additionalOccupants?.anyMinor),
    ),
  },
  otherInformation: {
    ...assignOtherInformation({ initialData, update }),
    aboutProperty: undefined,
    referralTypeId: undefined,
    petsInformation: undefined,
  },
});

export default getSecondaryFormPayload;
